import { render, staticRenderFns } from "./detail-tuijian.vue?vue&type=template&id=50dc2f19&"
import script from "./detail-tuijian.vue?vue&type=script&lang=js&"
export * from "./detail-tuijian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports